module.exports = __webpack_public_path__ + "444f8030e9dbd274c6e141305a92758c.svg";